import { inject, observer } from "mobx-react";
import * as React from "react";
import Icon from "src/components/Icon/Icon";
import { WeekDays } from "../../../constants/weekDays";
import { ILayoutStore } from "../../../store/LayoutStore";
import { IResultStore } from "src/store/ResultStore";

interface IResultsConsumptionProps {
  consumption: Array<{
    beerCount: number;
    cocktailCount: number;
    strongAlcoolCount: number;
    wineCount: number;
    dayIndex: number;
  }>;
  LayoutStore?: ILayoutStore;
  ResultStore?: IResultStore;
  scrollIntoViewRef: React.RefObject<HTMLDivElement>;
}

@inject("LayoutStore", "ResultStore")
@observer
class ResultsConsumption extends React.Component<IResultsConsumptionProps> {
  public constructor(props: IResultsConsumptionProps) {
    super(props);
    this.hideResultConsumption = this.hideResultConsumption.bind(this);
  }
  public render() {
    return (
      <div className="ResultsConsumption">
        <h4
          className={`ResultsConsumption__title${
            this.props.LayoutStore!.resultConsumptionIsVisible
              ? " ResultsConsumption__title--show"
              : ""
          }`}
        >
          La semaine dernière, vous avez consommé
        </h4>
        <ul
          className={`ResultsConsumption__weekdays${
            this.props.LayoutStore!.resultConsumptionIsVisible
              ? " ResultsConsumption__weekdays--show"
              : ""
          }`}
        >
          {this.props.consumption.map((cDay, index) => (
            <li className="ResultsConsumption__day" key={index}>
              <h5 className="ResultsConsumption__day-title">
                {this.getWeekDay(cDay.dayIndex)}
              </h5>
              <div className="ResultsConsumption__day-consumption-container">
                <div className="ResultsConsumption__day-consumption-row">
                  <Icon name="demi" />
                  <span className="ResultsConsumption__day-howmuch">
                    {cDay.beerCount}
                  </span>
                  <p className="ResultsConsumption__day-label">
                    demi(s) de bière
                  </p>
                </div>
                <div className="ResultsConsumption__day-consumption-row">
                  <Icon name="vin" />
                  <span className="ResultsConsumption__day-howmuch">
                    {cDay.wineCount}
                  </span>
                  <p className="ResultsConsumption__day-label">
                    verre(s) de vin
                  </p>
                </div>
                <div className="ResultsConsumption__day-consumption-row">
                  <Icon name="fort" />
                  <span className="ResultsConsumption__day-howmuch">
                    {cDay.strongAlcoolCount}
                  </span>
                  <p className="ResultsConsumption__day-label">
                    verre(s) d’alcool fort{" "}
                  </p>
                </div>
                <div className="ResultsConsumption__day-consumption-row">
                  <Icon name="cocktail" />
                  <span className="ResultsConsumption__day-howmuch">
                    {cDay.cocktailCount}
                  </span>
                  <p className="ResultsConsumption__day-label">cocktail(s)</p>
                </div>
              </div>
            </li>
          ))}
        </ul>
        <div
          className={`ResultsConsumption__control${
            this.props.LayoutStore!.resultConsumptionIsVisible
              ? " ResultsConsumption__control--show"
              : ""
          }`}
        >
          <button
            className="ResultsRepeatTest-btn ResultsConsumption__btn"
            onClick={this.hideResultConsumption}
          >
            Réduire
            <span>
              <Icon
                name="deplierred"
                iconClass={`${
                  this.props.ResultStore.rep1 === 0 &&
                  this.props.ResultStore.rep2 === 0 &&
                  this.props.ResultStore.rep3 === 0
                    ? "Icon--green"
                    : ""
                }`}
              />
            </span>
          </button>
        </div>
      </div>
    );
  }

  private getWeekDay(value: number) {
    const foundDay = WeekDays.find(el => el.value === value);
    if (!foundDay) {
      return "";
    }
    return foundDay.label;
  }

  private hideResultConsumption() {
    this.props.LayoutStore!.hideResultConsumption();
    this.props.scrollIntoViewRef.current.scrollIntoView({ behavior: "smooth" });
  }
}

export default ResultsConsumption;



// WEBPACK FOOTER //
// ./src/components/ResultsComponents/ResultsConsumption/ResultsConsumption.tsx